(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coleccion-pestanas-shrine"] && !Shopify.designMode) return;
  try {
    

/* ═══════════════════════════════════════════════════════════════════════
   CPS JavaScript — Tab switching, Sort, Load More (AJAX)
   Vanilla JS, class-based, multi-instance safe
═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Metal swatch gradient map ──────────────────────────────────── */
  const SWATCH_MAP = {
    'oro':         'radial-gradient(circle at 35% 30%,#fffce0 0%,#ffd700 28%,#d4a017 62%,#9a7010 100%)',
    'gold':        'radial-gradient(circle at 35% 30%,#fffce0 0%,#ffd700 28%,#d4a017 62%,#9a7010 100%)',
    'yellow-gold': 'radial-gradient(circle at 35% 30%,#fffce0 0%,#ffd700 28%,#d4a017 62%,#9a7010 100%)',
    'oro-amarillo':'radial-gradient(circle at 35% 30%,#fffce0 0%,#ffd700 28%,#d4a017 62%,#9a7010 100%)',
    'dorado':      'radial-gradient(circle at 35% 30%,#fffce0 0%,#ffd700 28%,#d4a017 62%,#9a7010 100%)',
    'oro-blanco':  'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'white-gold':  'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'whitegold':   'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'plata':       'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'silver':      'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'blanco':      'radial-gradient(circle at 35% 30%,#ffffff 0%,#e2e2e2 32%,#b0b0b0 65%,#888888 100%)',
    'oro-rosa':    'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)',
    'rose-gold':   'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)',
    'rosegold':    'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)',
    'rosado':      'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)',
    'rosa':        'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)',
    'pink':        'radial-gradient(circle at 35% 30%,#ffe4ec 0%,#f0a8b8 32%,#c27080 65%,#8a3050 100%)'
  };

  function swatchBg(value) {
    const key = value.toLowerCase().trim()
      .replace(/\s+/g, '-')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return SWATCH_MAP[key] || '#c8c8c8';
  }

  /* ── Resize Shopify CDN image ─────────────────────────────────── */
  function shopifyImg(src, width) {
    if (!src || typeof src !== 'string') return '';
    const base = src.startsWith('//') ? 'https:' + src : src;
    try {
      const u = new URL(base);
      u.searchParams.set('width', width);
      return src.startsWith('//') ? u.href.replace('https:', '') : u.href;
    } catch (e) { return src; }
  }

  /* ── HTML escape ──────────────────────────────────────────────── */
  function esc(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── Money formatter ──────────────────────────────────────────── */
  function money(priceStr, currency) {
    const amount = parseFloat(String(priceStr)) || 0;
    const cur    = currency || 'CLP';
    // Zero-decimal currencies (CLP, JPY, KRW…) show no decimals
    const zeroDecimal = ['CLP','JPY','KRW','VND','IDR','MMK'].includes(cur);
    try {
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: zeroDecimal ? 0 : 2,
        maximumFractionDigits: zeroDecimal ? 0 : 2
      }).format(amount);
    } catch (e) {
      return `$${amount.toLocaleString('es-CL')}`;
    }
  }

  /* ── Build swatch HTML for JS-rendered cards ──────────────────── */
  function buildSwatchesHtml(product, show) {
    if (!show || !Array.isArray(product.options)) return '';
    const idx = product.options.findIndex(o =>
      ['metal', 'material', 'color'].includes(o.toLowerCase().trim())
    );
    if (idx === -1) return '';
    const seen = new Set();
    const circles = (product.variants || []).reduce((acc, v) => {
      const val = v[`option${idx + 1}`];
      if (!val || seen.has(val)) return acc;
      seen.add(val);
      const bg = swatchBg(val);
      return acc + `<span class="cps-swatch cps-swatch--js" title="${esc(val)}" aria-label="${esc(val)}" style="background:${bg};"></span>`;
    }, '');
    return circles ? `<div class="cps-swatches">${circles}</div>` : '';
  }

  /* ── Build one product card HTML ──────────────────────────────── */
  function buildCard(p, opts) {
    const imgSrc = shopifyImg(p.featured_image, 640);
    const img    = imgSrc
      ? `<img src="${esc(imgSrc)}" alt="${esc(p.title)}" loading="lazy" class="cps-card__img" width="640" height="640">`
      : '<div class="cps-card__no-img"></div>';

    const price   = parseFloat(p.price   || 0);
    const compare = parseFloat(p.compare_at_price || 0);
    const hasSale = compare > price && compare > 0;
    const pct     = hasSale ? Math.round((compare - price) / compare * 100) : 0;

    const badge = (opts.showBadge && hasSale && pct > 0) ? `
      <div class="cps-badge" style="--cbg:${esc(opts.badgeColor || '#1a1a1a')};">
        <svg viewBox="0 0 12 12" fill="none" class="cps-badge__icon" aria-hidden="true">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z"
            fill="currentColor"/>
        </svg>
        <span>AHORRA&nbsp;${pct}%</span>
      </div>` : '';

    const priceHtml = hasSale
      ? `<span class="cps-price-sale">${money(p.price, opts.currency)}</span><s class="cps-price-was">${money(p.compare_at_price, opts.currency)}</s>`
      : `<span class="cps-price-reg">${money(p.price, opts.currency)}</span>`;

    const swatches = buildSwatchesHtml(p, opts.showSwatches);

    return `
      <li class="cps-card" data-pid="${p.id}">
        <a href="/products/${esc(p.handle)}" class="cps-card__link" tabindex="0">
          <div class="cps-card__img-wrap">
            ${badge}
            ${img}
          </div>
          <div class="cps-card__body">
            <h3 class="cps-card__title">${esc(p.title)}</h3>
            <p class="cps-card__price">${priceHtml}</p>
            ${swatches}
          </div>
        </a>
      </li>`;
  }

  /* ── Section controller class ──────────────────────────────────── */
  class CPSection {
    constructor(el) {
      this.el   = el;
      this.sid  = el.dataset.sectionId;
      this.cfg  = window.__CPS?.[this.sid] || {};

      // State
      this.state = {
        collection: this.cfg.collection || el.dataset.collection,
        perPage:    parseInt(this.cfg.perPage)       || 12,
        total:      parseInt(this.cfg.totalProducts) || 0,
        sortBy:     this.cfg.sortBy  || 'manual',
        page:       1,
        loading:    false
      };

      // Render options
      this.opts = {
        showBadge:    this.cfg.showBadge    !== false,
        showSwatches: this.cfg.showSwatches !== false,
        currency:     this.cfg.currency     || 'CLP',
        badgeColor:   this.cfg.badgeColor   || '#1a1a1a'
      };

      // Product cache: key = "handle::sortBy" → products[]
      this.cache = {};

      // DOM refs
      this.grid     = el.querySelector('[data-cps-grid]');
      this.lmWrap   = el.querySelector('[data-cps-lm]');
      this.countEl  = el.querySelector('[data-cps-count]');
      this.sortSel  = el.querySelector('.cps-sort-sel');
      this.tabs     = Array.from(el.querySelectorAll('.cps-tab'));

      this._bind();
      this._syncLoadMore();
    }

    /* ── Event binding ────────────────────────────────────────── */
    _bind() {
      // Tabs
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const h = tab.dataset.handle;
          if (!h || this.state.loading) return;
          if (h === this.state.collection) return; // already active
          this.state.collection = h;
          this.state.page       = 1;
          this._setActiveTab(tab);
          this._load(false);
        });
      });

      // Sort
      if (this.sortSel) {
        this.sortSel.value = this.state.sortBy;
        this.sortSel.addEventListener('change', () => {
          if (this.state.loading) return;
          this.state.sortBy = this.sortSel.value;
          this.state.page   = 1;
          this._load(false);
        });
      }

      // Load more
      this.el.addEventListener('click', e => {
        if (e.target.closest('[data-cps-load-more]') && !this.state.loading) {
          this.state.page++;
          this._load(true);
        }
      });
    }

    /* ── Fetch & cache products ─────────────────────────────── */
    async _fetch(collection, sortBy) {
      const key = `${collection}::${sortBy}`;
      if (this.cache[key]) return this.cache[key];
      // Fetch up to 250 — covers most jewelry collections
      const url = `/collections/${collection}/products.json?sort_by=${sortBy}&limit=250`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const { products } = await res.json();
      this.cache[key] = products || [];
      return this.cache[key];
    }

    /* ── Main load/render ────────────────────────────────────── */
    async _load(append) {
      this.state.loading = true;
      this.grid.classList.add('cps-grid--loading');

      // Show spinner on load-more button
      const btn    = this.lmWrap?.querySelector('[data-cps-load-more]');
      const lbl    = btn?.querySelector('[data-cps-btn-lbl]');
      const spin   = btn?.querySelector('[data-cps-spinner]');
      if (append && btn) {
        btn.disabled = true;
        if (lbl)  lbl.style.visibility = 'hidden';
        if (spin) spin.style.display   = 'inline-block';
      }

      try {
        const all  = await this._fetch(this.state.collection, this.state.sortBy);
        // Update state total from cached list
        this.state.total = all.length;

        const slice = all.slice(0, this.state.page * this.state.perPage);
        const cards = slice.map(p => buildCard(p, this.opts)).join('');

        if (append) {
          // Append only new cards (items beyond previous page)
          const prev     = (this.state.page - 1) * this.state.perPage;
          const newSlice = all.slice(prev, this.state.page * this.state.perPage);
          const newCards = newSlice.map(p => buildCard(p, this.opts)).join('');
          this.grid.insertAdjacentHTML('beforeend', newCards);
        } else {
          this.grid.innerHTML = cards ||
            '<li class="cps-empty">Esta colección no tiene productos disponibles.</li>';
          // Smooth scroll back to grid top when switching tabs / sorting
          if (!append) {
            this.grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }

        // Update counter
        if (this.countEl && this.cfg.showCount !== false) {
          const n   = this.state.total;
          const sfx = n !== 1 ? 's' : '';
          this.countEl.textContent = `${n} producto${sfx}`;
        }

        this._syncLoadMore();
      } catch (err) {
        console.error('[CPS] load error:', err);
        if (!append) {
          this.grid.innerHTML = '<li class="cps-empty">Error al cargar los productos.</li>';
        }
        // Revert page on error
        if (append) this.state.page--;
      } finally {
        this.state.loading = false;
        this.grid.classList.remove('cps-grid--loading');
        if (append && btn) {
          btn.disabled = false;
          if (lbl)  lbl.style.visibility = 'visible';
          if (spin) spin.style.display   = 'none';
        }
      }
    }

    /* ── Active tab highlight ────────────────────────────────── */
    _setActiveTab(activeTab) {
      this.tabs.forEach(t => {
        const on = t === activeTab;
        t.classList.toggle('cps-tab--active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    /* ── Load more button visibility ─────────────────────────── */
    _syncLoadMore() {
      if (!this.lmWrap) return;
      const btn    = this.lmWrap.querySelector('[data-cps-load-more]');
      if (!btn) return;
      const loaded = this.state.page * this.state.perPage;
      btn.style.display = loaded >= this.state.total ? 'none' : '';
    }
  }

  /* ── Init all instances on the page ───────────────────────────── */
  function init() {
    document.querySelectorAll('.cps-section[data-section-id]').forEach(el => {
      if (!el.__cpsCtrl) el.__cpsCtrl = new CPSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor live updates
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', e => {
      const el = e.target?.querySelector?.('.cps-section[data-section-id]');
      if (el && !el.__cpsCtrl) el.__cpsCtrl = new CPSection(el);
    });
    document.addEventListener('shopify:section:reorder', init);
  }

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-replicate-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initDawnLoopPro);
  document.addEventListener('shopify:section:load', initDawnLoopPro);

  function initDawnLoopPro() {
    const sections = document.querySelectorAll('.vvega-loop-section');

    sections.forEach(section => {
      const track = section.querySelector('.vvega-loop-track');
      if (!track) return;
      
      track.querySelectorAll('.is-clone').forEach(clone => clone.remove());
      
      const realSlides = Array.from(track.querySelectorAll('.real-slide'));
      if (realSlides.length < 2) return;

      let currentIndex = 1;
      let isDragging = false;
      let startX = 0;
      let startY = 0;
      const threshold = 40;

      // 1. Crear los clones para el bucle infinito bidireccional
      const firstClone = realSlides[0].cloneNode(true);
      const lastClone = realSlides[realSlides.length - 1].cloneNode(true);
      
      firstClone.classList.add('is-clone');
      firstClone.classList.remove('real-slide');
      lastClone.classList.add('is-clone');
      lastClone.classList.remove('real-slide');

      track.appendChild(firstClone);
      track.insertBefore(lastClone, realSlides[0]);

      const allSlides = Array.from(track.querySelectorAll('.vvega-loop-slide'));

      // 2. Función de actualización de posición
      function updatePosition(instant = false) {
        if (window.innerWidth >= 768) return;

        if (instant) {
          track.classList.add('is-instant');
        } else {
          track.classList.remove('is-instant');
        }

        const moveVW = -(currentIndex * 75) + 12.5;
        track.style.transform = `translateX(${moveVW}vw)`;

        allSlides.forEach((slide, index) => {
          if (index === currentIndex) {
            slide.classList.add('is-active');
          } else {
            slide.classList.remove('is-active');
          }
        });

        if (instant) {
          track.offsetHeight; /* Forzar reflow para evitar parpadeos */
          requestAnimationFrame(() => {
            track.classList.remove('is-instant');
          });
        }
      }

      // 3. Listener del final de transición (Bucle mágico)
      track.addEventListener('transitionend', (e) => {
        if (e.target !== track || window.innerWidth >= 768) return;
        
        // Si llegó al clon de la derecha
        if (currentIndex === allSlides.length - 1) {
          currentIndex = 1;
          updatePosition(true);
        } 
        // Si llegó al clon de la izquierda
        else if (currentIndex === 0) {
          currentIndex = allSlides.length - 2;
          updatePosition(true); 
        }
      });

      // 4. Controladores táctiles con bloqueo de scroll vertical
      track.addEventListener('touchstart', touchStart, {passive: true});
      // Importante: passive: false permite usar preventDefault() para bloquear el scroll vertical
      track.addEventListener('touchmove', touchMove, {passive: false});
      track.addEventListener('touchend', touchEnd);

      function touchStart(event) {
        if (window.innerWidth >= 768) return;
        isDragging = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        
        // Si tocan justo en un borde (clon), forzamos el salto ANTES de que arrastren
        if (currentIndex === 0) {
          currentIndex = allSlides.length - 2;
          updatePosition(true);
        } else if (currentIndex === allSlides.length - 1) {
          currentIndex = 1;
          updatePosition(true);
        }
      }

      function touchMove(event) {
        if (!isDragging || window.innerWidth >= 768) return;

        const currentX = event.touches[0].clientX;
        const currentY = event.touches[0].clientY;
        
        const diffX = Math.abs(currentX - startX);
        const diffY = Math.abs(currentY - startY);

        // Si el usuario se está moviendo más en horizontal que en vertical, bloqueamos el scroll nativo de la página
        if (diffX > diffY) {
          if (event.cancelable) {
            event.preventDefault();
          }
        }
      }

      function touchEnd(event) {
        if (!isDragging || window.innerWidth >= 768) return;
        isDragging = false;
        
        const endX = event.changedTouches[0].clientX;
        const diffX = startX - endX;

        if (diffX > threshold) {
          currentIndex++; // Deslizar izquierda (Siguiente)
        } else if (diffX < -threshold) {
          currentIndex--; // Deslizar derecha (Anterior)
        }
        
        // Seguridad anti-salida de límites
        if (currentIndex < 0) currentIndex = 0;
        if (currentIndex >= allSlides.length) currentIndex = allSlides.length - 1;
        
        updatePosition(false);
      }

      // Reinicio seguro en redimensionamientos
      window.addEventListener('resize', () => updatePosition(true));
      setTimeout(() => updatePosition(true), 50);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vvega-before-after-loop"] && !Shopify.designMode) return;
  try {
    
  function initSplitSliderVvega() {
    const sliderWrappers = document.querySelectorAll('[data-split-slider]');

    sliderWrappers.forEach(wrapper => {
      const handle = wrapper.querySelector('[data-slider-handle]');
      const afterLayers = wrapper.querySelectorAll('[data-after-layer]');
      let isDragging = false;

      const setSplit = (clientX) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        let currentPosition = (clientX - wrapperRect.left) / wrapperRect.width * 100;
        currentPosition = Math.max(0, Math.min(100, currentPosition));

        handle.style.left = `${currentPosition}%`;
        const clipRight = 100 - currentPosition;
        afterLayers.forEach(layer => {
          layer.style.clipPath = `inset(0 ${clipRight}% 0 0)`;
        });
      };

      const startDrag = (e) => { 
        isDragging = true; 
        setSplit(e.clientX || e.touches[0].clientX); 
      };
      
      const moveDrag = (e) => { 
        if (!isDragging) return; 
        // MAGIA JS: Evita que la pantalla se deslice arriba/abajo mientras se usa el slider
        if (e.cancelable) {
          e.preventDefault(); 
        }
        setSplit(e.clientX || e.touches[0].clientX); 
      };
      
      const endDrag = () => { 
        isDragging = false; 
      };

      wrapper.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      
      wrapper.addEventListener('touchstart', startDrag, {passive: true});
      // {passive: false} es obligatorio para que e.preventDefault() funcione en dispositivos móviles
      window.addEventListener('touchmove', moveDrag, {passive: false});
      window.addEventListener('touchend', endDrag);
    });
  }

  document.addEventListener('DOMContentLoaded', initSplitSliderVvega);
  document.addEventListener('shopify:section:load', initSplitSliderVvega);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vvega-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initVvegaFaq);
  document.addEventListener('shopify:section:load', initVvegaFaq);

  function initVvegaFaq() {
    const sections = document.querySelectorAll('.vvega-faq-section');

    sections.forEach(section => {
      const tabsWrapper = section.querySelector('.vvega-faq-tabs');
      const thumb = section.querySelector('.vvega-faq-tabs-bar-thumb-compact');
      const track = section.querySelector('.vvega-faq-tabs-bar-track-compact');
      const tabs = section.querySelectorAll('.vvega-faq-tab');
      const grids = section.querySelectorAll('.vvega-faq-grid');

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('is-active'));
          grids.forEach(g => g.classList.remove('is-active'));

          tab.classList.add('is-active');
          const targetId = tab.getAttribute('data-target');
          const targetGrid = document.getElementById(`faq-grid-${targetId}`);
          if (targetGrid) {
            targetGrid.classList.add('is-active');
          }
        });
      });

      const faqHeaders = section.querySelectorAll('.vvega-faq-header');

      faqHeaders.forEach(header => {
        header.addEventListener('click', () => {
          const card = header.parentElement;
          const body = card.querySelector('.vvega-faq-body');
          const isOpen = card.classList.contains('is-open');

          if (isOpen) {
            card.classList.remove('is-open');
            body.style.maxHeight = null;
            header.setAttribute('aria-expanded', 'false');
          } else {
            card.classList.add('is-open');
            body.style.maxHeight = body.scrollHeight + "px";
            header.setAttribute('aria-expanded', 'true');
          }
        });
      });

      function updateScrollThumb() {
        if (window.innerWidth >= 768 || !tabsWrapper || !thumb || !track) return;

        const scrollLeft = tabsWrapper.scrollLeft;
        const scrollWidth = tabsWrapper.scrollWidth;
        const clientWidth = tabsWrapper.clientWidth;
        
        if (scrollWidth > clientWidth) {
          track.style.display = 'block';
          
          const thumbWidthPercentage = (clientWidth / scrollWidth) * 100;
          thumb.style.width = `${thumbWidthPercentage}%`;
          
          const maxScroll = scrollWidth - clientWidth;
          const scrollPercentage = scrollLeft / maxScroll;
          
          const maxLeftPos = 100 - thumbWidthPercentage;
          const currentLeftPos = scrollPercentage * maxLeftPos;
          
          thumb.style.left = `${currentLeftPos}%`;
        } else {
          track.style.display = 'none';
        }
      }

      if (tabsWrapper) {
        tabsWrapper.addEventListener('scroll', updateScrollThumb, {passive: true});
        window.addEventListener('resize', updateScrollThumb);
        setTimeout(updateScrollThumb, 100); 
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
